import React, {useEffect} from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import OutputText from '@ey/canvascoreservices/OutputText';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {navigationIcMoreVert24px} from '@ey/motif-react-wrapper/assets/icons';
import UserItem from './UserItem';
import {contentIcAddCircle24px} from '@ey/motif-react-wrapper/assets/icons';

function EngagementItem(props) {
	const engagementDescription = `${props.data.engagementDescription ? props.data.engagementDescription : ''}`;
	const engagementId = `${props.data.canvasEngagementId ? props.data.canvasEngagementId : ''}`;
	const clientEngagementName = `${props.data.clientEngagementName ? props.data.clientEngagementName : ''}`;
	const clientEngagementCode = `${props.data.clientEngagementCode ? props.data.clientEngagementCode : ''}`;
	const dataLoaded = props.countryName && props.regionName;
	const {showDetailsSwitch, showDetailsToggleSwitch, showTabName} = props;

	useEffect(() => {}, [showDetailsSwitch]);
	return (
		<StyledEngagementItemSection className={`engagement-wrap`}>
			{props.isItemDraggable && (
				<section className="icon-wrap">
					<MotifIcon src={navigationIcMoreVert24px} />
					<MotifIcon className="motif-icon icon2" src={navigationIcMoreVert24px} />
				</section>
			)}

			{
				<section className={`step3-connected-eng-wrap ${showDetailsSwitch ? 'show-details' : 'show-no-details'}`}>
					<span className={'engagement-name-wrap'}>
						<OutputText body2 ellipsis>
							{engagementDescription}
						</OutputText>
						<span className="separator"> -</span>
						<span title={engagementId} className="eng-id">
							<span className="eng-id-wrap">
								<OutputText body2 ellipsis>
									{labels.idLabel}:
								</OutputText>
							</span>
							<OutputText body2 ellipsis>
								{engagementId}
							</OutputText>
						</span>
					</span>
					<span className={'client-name-wrap'}>
						<span className="client-name">
							<span className="client-label-wrap">
								<OutputText body2 light ellipsis>
									{labels.client}:
								</OutputText>
							</span>
							<OutputText body2 light ellipsis>
								{clientEngagementName}
							</OutputText>
						</span>
						<span className="separator"> -</span>
						<span className="client-code">
							<span className="code-label-wrap">
								<OutputText body2 light ellipsis>
									{labels.codeLabel}:
								</OutputText>
							</span>
							<OutputText body2 light ellipsis>
								{clientEngagementCode}
							</OutputText>
						</span>
					</span>
					{showDetailsSwitch && (
						<UserItem
							users={props.data.users}
							noDataLoadedLabel={!dataLoaded && labels.noDataAvailableLabel}
						></UserItem>
					)}
				</section>
			}

			{props.showRemoveIcon && (
				<MotifIcon
					id=""
					className="clear-row"
					onClick={() => props.onRemoveItem(props.data.entityId, props.data.canvasEngagementId)}
					src={contentIcAddCircle24px}
					title={labels.remove}
				/>
			)}
		</StyledEngagementItemSection>
	);
}

export default EngagementItem;

const StyledEngagementItemSection = styled.section`
	background-color: ${(props) => props.theme.color[`white`]};
	display: flex;
	flex-direction: column;
	padding: 0.5rem 2.5rem;
	width: 100%;
	position: relative;
	justify-content: center;

	.step3-connected-eng-wrap{
		width: 93%;
		display: flex;
    	flex-direction: column;
    	gap: var(--spacing-x-small);
	}

	.client-name-wrap {
		font-size: 1.2rem;
	}

	.clear-row {
		transform: rotate(135deg);
		display: inline-block;
		width: 2rem;
		height: 2rem;
		svg{
			max-width: 2rem;
			max-height: 2rem;
			fill: ${(props) => props.theme.color[`black`]};
		}
	}

	.icon-wrap {
		display: none;
		position: absolute;
		left: 0;
		.motif-icon {
			svg {
				width: 2rem !important;
				height: 2rem !important;
				fill: ${(props) => props.theme.color[`grey300`]};
			}
			&.icon2 {
				margin-left: -1.4rem;
			}
		}
	}
	&:hover {
		cursor: pointer;
		.icon-wrap {
			display: block;
		}
	}

	.engagement-name-wrap,
	.client-name-wrap {
		display: flex;
		width: 100%;
		span {
			&.eng-name,
			&.client-name {
				max-width: 50%;
				word-break: break-word;
			}
			&.eng-id,
			&.client-code {
				max-width: 50%;
			}
		}
	}
	.engagement-name-wrap {
		span {
			&.eng-name{
				@media only screen and (min-width: 1920px) {
					max-width: 35rem;
				}
				@media only screen and (min-width: 1366px) and (max-width: 1919px) {
					max-width: 24rem;
				}

				&.multi-line-ellipsis{
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;  
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
	}
	

	.ellipsis {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: inline-block;
	}
	.separator {
		margin: 0 0.5rem;
	}
`;
